import { useState } from 'react'

import { CustomFormCommonEntityFilter } from 'components/tools/CustomForm/components/Viewer/components/CustomFormViewerQuestion/components/CustomFormViewerQuestionSelection/components/CustomFormEntitiesQuestions/components/CustomFormCommonEntitySelectionDrawer/types'
import getEntityOnCustomForm from './services/getEntityOnCustomForm'

export default function useGetCommonEntityByID() {
  const [loadingEntity, setLoadingEntity] = useState<boolean>(false)
  const [entity, setEntity] = useState<CustomFormCommonEntityFilter>({})

  async function getEntity({ entityKey, entityId }: { entityKey: string; entityId: string }) {
    setLoadingEntity(true)

    const formatEntityKey = entityKey === 'org_unit' ? 'organizational-unit' : entityKey
    const response = await getEntityOnCustomForm({ entityKey: formatEntityKey, id: entityId })
    let entityFromAPI = {}
    if (response?.header?.success) {
      entityFromAPI = response?.body?.[entityKey.replace('-', '_')]
      setEntity(entityFromAPI)
    }
    setLoadingEntity(false)
    return entityFromAPI
  }

  return { getEntity, entity, loadingEntity }
}
